import * as React from "react";

export const LevelOne = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <circle cx={22} cy={22} r={22} fill="#169FED" />
    <path
      stroke="#fff"
      strokeWidth={4.178}
      d="M11.836 17.245c.232-2.204 1.88-6.335 6.614-5.221 5.919 1.392 4.526 7.31 4.526 7.658 0 .348-6.266 9.748 1.044 12.185 5.849 1.95 7.543-1.973 7.66-4.178"
    />
  </svg>
);
